import { memo, useCallback } from 'react'
import { TableColumnsType, Table } from 'antd'
import { PlayersRatings } from 'types/players-ratings'

type Props = {
    data: PlayersRatings[]
}

export const ExpandableRow = memo((props: Props) => {
    const { data } = props

    const columns: TableColumnsType<PlayersRatings> = [
        { title: 'League Type', dataIndex: ['leagueType', 'name'] },
        { title: 'League Division', dataIndex: ['leagueDivision', 'name'] },
        { title: 'Old Rating', dataIndex: 'oldRating' },
        { title: 'Rating', dataIndex: 'rating' },
        { title: 'Wins', dataIndex: 'wins' },
        { title: 'Draws', dataIndex: 'draws' },
        { title: 'Losses', dataIndex: 'losses' },
    ]

    const getRowKey = useCallback((record: PlayersRatings) => {
        return `${record.playerId}-${record.leagueType.id}-${record.leagueDivision.id}`
    }, [])

    return (
        <>
            <Table columns={columns} dataSource={data} pagination={false} rowKey={getRowKey} />
        </>
    )
})
